
import { PvdLink, PvdPopover } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';
import { PopoverContent } from '../../client.constants';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Popover extends Vue {
    headerId = '';
    contentId = '';
    cyHeaderId = '';
    cyContentId = '';
    heading = '';
    text = '';

    @Prop() popoverType!: string;

    created() {
        const entry = PopoverContent.find(
            (entry) => entry.key == this.popoverType
        );
        this.headerId = (entry?.id ?? '') + '-popover-header-id';
        this.cyHeaderId = (entry?.id ?? '') + '-popover-header-cy';
        this.contentId = (entry?.id ?? '') + '-popover-content-id';
        this.cyContentId = (entry?.id ?? '') + '-popover-content-cy';
        this.heading = entry?.heading ?? '';
        this.text = entry?.text ?? '';
    }

    setTarget(trigger: PvdLink) {
        (this.$refs['ref-popover__popover'] as PvdPopover).pvdTarget = trigger;
    }

    openModal() {
        (this.$refs['ref-popover__popover'] as PvdPopover).pvdOpen = true;
    }
}
